'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _downshift = require('downshift');

var _downshift2 = _interopRequireDefault(_downshift);

var _emotionTheming = require('emotion-theming');

var _hoistNonReactStatics = require('hoist-non-react-statics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _actions = require('@appbaseio/reactivecore/lib/actions');

var _helper = require('@appbaseio/reactivecore/lib/utils/helper');

var _types = require('@appbaseio/reactivecore/lib/utils/types');

var _types2 = _interopRequireDefault(_types);

var _suggestions = require('@appbaseio/reactivecore/lib/utils/suggestions');

var _suggestions2 = _interopRequireDefault(_suggestions);

var _causes = require('@appbaseio/reactivecore/lib/utils/causes');

var _causes2 = _interopRequireDefault(_causes);

var _Title = require('../../styles/Title');

var _Title2 = _interopRequireDefault(_Title);

var _Input = require('../../styles/Input');

var _Input2 = _interopRequireDefault(_Input);

var _CancelSvg = require('../shared/CancelSvg');

var _CancelSvg2 = _interopRequireDefault(_CancelSvg);

var _SearchSvg = require('../shared/SearchSvg');

var _SearchSvg2 = _interopRequireDefault(_SearchSvg);

var _InputIcon = require('../../styles/InputIcon');

var _InputIcon2 = _interopRequireDefault(_InputIcon);

var _Container = require('../../styles/Container');

var _Container2 = _interopRequireDefault(_Container);

var _utils = require('../../utils');

var _SuggestionItem = require('./addons/SuggestionItem');

var _SuggestionItem2 = _interopRequireDefault(_SuggestionItem);

var _SuggestionWrapper = require('./addons/SuggestionWrapper');

var _SuggestionWrapper2 = _interopRequireDefault(_SuggestionWrapper);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Text = (0, _emotionTheming.withTheme)(function (props) {
  return _react2.default.createElement('span', {
    className: 'trim',
    style: {
      color: props.primary ? props.theme.colors.primaryColor : props.theme.colors.textColor
    }
  }, props.children);
});

var CategorySearch = function (_Component) {
  _inherits(CategorySearch, _Component);

  function CategorySearch(props) {
    _classCallCheck(this, CategorySearch);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    var value = props.value || props.defaultValue || {}; // eslint-disable-next-line

    var _value$term = value.term,
        currentValue = _value$term === undefined ? '' : _value$term,
        _value$category = value.category,
        currentCategory = _value$category === undefined ? null : _value$category; // add preference to selected-X value from URL/SSR

    currentValue = props.selectedValue || currentValue;
    currentCategory = props.selectedCategory || currentCategory;
    _this.state = {
      currentValue: currentValue,
      currentCategory: currentCategory,
      suggestions: [],
      isOpen: false
    };
    _this.internalComponent = props.componentId + '__internal';
    _this.locked = false;
    _this.queryOptions = {
      size: 20
    };
    props.addComponent(props.componentId);
    props.addComponent(_this.internalComponent);
    props.setQueryListener(props.componentId, props.onQueryChange, null);

    if (props.highlight) {
      var queryOptions = CategorySearch.highlightQuery(props) || {};
      queryOptions.size = 20;
      _this.queryOptions = queryOptions;
      props.setQueryOptions(props.componentId, queryOptions);
    } else {
      props.setQueryOptions(props.componentId, _this.queryOptions);
    }

    _this.setReact(props);

    var aggsQuery = _this.getAggsQuery(props.categoryField);

    props.setQueryOptions(_this.internalComponent, aggsQuery, false);
    var hasMounted = false;
    var cause = null;

    if (currentValue) {
      _this.setValue(currentValue, true, props, currentCategory, cause, hasMounted);
    }

    return _this;
  }

  CategorySearch.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;

    (0, _helper.checkSomePropChange)(this.props, prevProps, ['highlight', 'dataField', 'highlightField'], function () {
      var queryOptions = CategorySearch.highlightQuery(_this2.props) || {};
      queryOptions.size = 20;
      _this2.queryOptions = queryOptions;

      _this2.props.setQueryOptions(_this2.props.componentId, queryOptions);
    });
    (0, _helper.checkPropChange)(this.props.react, prevProps.react, function () {
      return _this2.setReact(_this2.props);
    });

    if (Array.isArray(this.props.suggestions) && this.state.currentValue.trim().length) {
      // shallow check allows us to set suggestions even if the next set
      // of suggestions are same as the current one
      if (this.props.suggestions !== prevProps.suggestions) {
        if (this.props.onSuggestions) {
          this.props.onSuggestions(this.props.suggestions);
        } // eslint-disable-next-line


        this.setState({
          suggestions: this.onSuggestions(this.props.suggestions)
        });
      }
    }

    (0, _helper.checkSomePropChange)(this.props, prevProps, ['fieldWeights', 'fuzziness', 'queryFormat', 'dataField', 'categoryField', 'nestedField'], function () {
      _this2.updateQuery(_this2.props.componentId, _this2.state.currentValue, _this2.props);
    });

    if (!(0, _helper.isEqual)(this.props.value, prevProps.value)) {
      var _props$value = this.props.value,
          currentValue = _props$value.term,
          _props$value$category = _props$value.category,
          currentCategory = _props$value$category === undefined ? null : _props$value$category;
      this.setValue(currentValue, true, this.props, currentCategory);
    } else if ( // since, selectedValue will be updated when currentValue changes,
    // we must only check for the changes introduced by
    // clear action from SelectedFilters component in which case,
    // the currentValue will never match the updated selectedValue
    this.props.selectedValue !== prevProps.selectedValue && this.state.currentValue !== this.props.selectedValue) {
      var _props = this.props,
          value = _props.value,
          onChange = _props.onChange;

      if (value === undefined) {
        this.setValue(this.props.selectedValue || '', true, this.props, this.props.selectedCategory);
      } else if (onChange) {
        // value prop exists
        onChange({
          term: this.props.selectedValue || '',
          category: this.props.selectedCategory || null
        });
      } else {
        // value prop exists and onChange is not defined:
        // we need to put the current value back into the store
        // if the clear action was triggered by interacting with
        // selected-filters component
        this.setValue(this.state.currentValue, true, this.props, this.state.currentCategory);
      }
    }
  };

  CategorySearch.prototype.componentWillUnmount = function componentWillUnmount() {
    this.props.removeComponent(this.props.componentId);
    this.props.removeComponent(this.internalComponent);
  };

  CategorySearch.prototype.render = function render() {
    var _this3 = this;

    var suggestionsList = [];
    var finalSuggestionsList = [];
    var currentValue = this.state.currentValue;
    var _props2 = this.props,
        theme = _props2.theme,
        themePreset = _props2.themePreset,
        renderAllSuggestions = _props2.renderAllSuggestions,
        categories = _props2.categories; // filter out empty categories

    var filteredCategories = categories.filter(function (category) {
      return Boolean(category.key);
    });

    if (!this.state.currentValue && this.props.defaultSuggestions && this.props.defaultSuggestions.length) {
      finalSuggestionsList = this.props.defaultSuggestions;
    } else if (this.state.currentValue) {
      suggestionsList = this.state.suggestions;
    }

    if (this.state.currentValue && this.state.suggestions.length && filteredCategories.length) {
      var categorySuggestions = [{
        label: this.state.currentValue + ' in all categories',
        value: this.state.currentValue,
        category: '*',
        // no source object exists for category based suggestions
        source: null
      }, {
        label: this.state.currentValue + ' in ' + filteredCategories[0].key,
        value: this.state.currentValue,
        category: filteredCategories[0].key,
        source: null
      }];

      if (filteredCategories.length > 1) {
        categorySuggestions = [].concat(categorySuggestions, [{
          label: this.state.currentValue + ' in ' + filteredCategories[1].key,
          value: this.state.currentValue,
          category: filteredCategories[1].key,
          source: null
        }]);
      }

      finalSuggestionsList = [].concat(categorySuggestions, suggestionsList);
    }

    return _react2.default.createElement(_Container2.default, {
      style: this.props.style,
      className: this.props.className
    }, this.props.title && _react2.default.createElement(_Title2.default, {
      className: (0, _helper.getClassName)(this.props.innerClass, 'title') || null
    }, this.props.title), this.props.defaultSuggestions || this.props.autosuggest ? _react2.default.createElement(_downshift2.default, _extends({
      id: this.props.componentId + '-downshift',
      onChange: this.onSuggestionSelected,
      onStateChange: this.handleStateChange,
      isOpen: this.state.isOpen,
      itemToString: function itemToString(i) {
        return i;
      },
      render: function render(_ref) {
        var getInputProps = _ref.getInputProps,
            getItemProps = _ref.getItemProps,
            isOpen = _ref.isOpen,
            highlightedIndex = _ref.highlightedIndex;
        return _react2.default.createElement('div', {
          className: _Input.suggestionsContainer
        }, _react2.default.createElement(_Input2.default, _extends({
          innerRef: function innerRef(c) {
            _this3._inputRef = c;
          },
          showClear: _this3.props.showClear,
          id: _this3.props.componentId + '-input',
          showIcon: _this3.props.showIcon,
          iconPosition: _this3.props.iconPosition
        }, getInputProps({
          className: (0, _helper.getClassName)(_this3.props.innerClass, 'input'),
          placeholder: _this3.props.placeholder,
          value: _this3.state.currentValue === null ? '' : _this3.state.currentValue,
          onChange: _this3.onInputChange,
          onBlur: _this3.props.onBlur,
          onFocus: _this3.handleFocus,
          onKeyPress: _this3.props.onKeyPress,
          onKeyDown: function onKeyDown(e) {
            return _this3.handleKeyDown(e, highlightedIndex);
          },
          onKeyUp: _this3.props.onKeyUp
        }), {
          themePreset: themePreset
        })), _this3.renderIcons(), _this3.renderLoader(), _this3.renderError(), renderAllSuggestions && renderAllSuggestions({
          currentValue: _this3.state.currentValue,
          isOpen: isOpen,
          getItemProps: getItemProps,
          highlightedIndex: highlightedIndex,
          suggestions: _this3.props.suggestions,
          categories: filteredCategories,
          parsedSuggestions: suggestionsList
        }), !renderAllSuggestions && isOpen && finalSuggestionsList.length ? _react2.default.createElement('ul', {
          className: (0, _Input.suggestions)(themePreset, theme) + ' ' + (0, _helper.getClassName)(_this3.props.innerClass, 'list')
        }, finalSuggestionsList.slice(0, 10).map(function (item, index) {
          return _react2.default.createElement('li', _extends({}, getItemProps({
            item: item
          }), {
            key: index + 1 + '-' + item.value,
            style: {
              backgroundColor: _this3.getBackgroundColor(highlightedIndex, index)
            }
          }), _react2.default.createElement(Text, {
            primary: !!item.category
          }, _react2.default.createElement(_SuggestionItem2.default, {
            currentValue: currentValue,
            suggestion: item
          })));
        })) : _this3.renderNoSuggestion(finalSuggestionsList));
      }
    }, this.props.downShiftProps)) : _react2.default.createElement('div', {
      className: _Input.suggestionsContainer
    }, _react2.default.createElement(_Input2.default, {
      innerRef: function innerRef(c) {
        _this3._inputRef = c;
      },
      className: (0, _helper.getClassName)(this.props.innerClass, 'input'),
      placeholder: this.props.placeholder,
      value: this.state.currentValue ? this.state.currentValue : '',
      onChange: this.onInputChange,
      onBlur: this.props.onBlur,
      onFocus: this.props.onFocus,
      onKeyPress: this.props.onKeyPress,
      onKeyDown: this.props.onKeyDown,
      onKeyUp: this.props.onKeyUp,
      autoFocus: this.props.autoFocus,
      iconPosition: this.props.iconPosition,
      showClear: this.props.showClear,
      showIcon: this.props.showIcon,
      themePreset: themePreset
    }), this.renderIcons()));
  };

  return CategorySearch;
}(_react.Component);

CategorySearch.highlightQuery = function (props) {
  if (props.customHighlight) {
    return props.customHighlight(props);
  }

  if (!props.highlight) {
    return null;
  }

  var fields = {};
  var highlightField = props.highlightField ? props.highlightField : props.dataField;

  if (typeof highlightField === 'string') {
    fields[highlightField] = {};
  } else if (Array.isArray(highlightField)) {
    highlightField.forEach(function (item) {
      fields[item] = {};
    });
  }

  return {
    highlight: {
      pre_tags: ['<mark>'],
      post_tags: ['</mark>'],
      fields: fields
    }
  };
};

CategorySearch.defaultQuery = function (value, props, category) {
  var finalQuery = null;
  var fields = void 0;

  if (value) {
    if (Array.isArray(props.dataField)) {
      fields = props.dataField;
    } else {
      fields = [props.dataField];
    }

    finalQuery = {
      bool: {
        should: CategorySearch.shouldQuery(value, fields, props),
        minimum_should_match: '1'
      }
    };

    if (category && category !== '*') {
      var _term;

      finalQuery = [finalQuery, {
        term: (_term = {}, _term[props.categoryField] = category, _term)
      }];
    }
  }

  if (value === '') {
    finalQuery = {
      match_all: {}
    };
  }

  if (finalQuery && props.nestedField) {
    finalQuery = {
      nested: {
        path: props.nestedField,
        query: finalQuery
      }
    };
  }

  return finalQuery;
};

CategorySearch.shouldQuery = function (value, dataFields, props) {
  var fields = dataFields.map(function (field, index) {
    return '' + field + (Array.isArray(props.fieldWeights) && props.fieldWeights[index] ? '^' + props.fieldWeights[index] : '');
  });

  if (props.queryFormat === 'and') {
    return [{
      multi_match: {
        query: value,
        fields: fields,
        type: 'cross_fields',
        operator: 'and'
      }
    }, {
      multi_match: {
        query: value,
        fields: fields,
        type: 'phrase_prefix',
        operator: 'and'
      }
    }];
  }

  return [{
    multi_match: {
      query: value,
      fields: fields,
      type: 'best_fields',
      operator: 'or',
      fuzziness: props.fuzziness ? props.fuzziness : 0
    }
  }, {
    multi_match: {
      query: value,
      fields: fields,
      type: 'phrase_prefix',
      operator: 'or'
    }
  }];
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.getAggsQuery = function (field) {
    var _aggs;

    return {
      aggs: (_aggs = {}, _aggs[field] = {
        terms: {
          field: field
        }
      }, _aggs)
    };
  };

  this.setReact = function (props) {
    var react = props.react;

    if (react) {
      var newReact = (0, _helper.pushToAndClause)(react, _this4.internalComponent);
      props.watchComponent(props.componentId, newReact);
    } else {
      props.watchComponent(props.componentId, {
        and: _this4.internalComponent
      });
    }
  };

  this.onSuggestions = function (searchSuggestions) {
    var renderSuggestion = _this4.props.renderSuggestion;
    var fields = Array.isArray(_this4.props.dataField) ? _this4.props.dataField : [_this4.props.dataField];
    var parsedSuggestions = (0, _suggestions2.default)(fields, searchSuggestions, _this4.state.currentValue.toLowerCase());

    if (renderSuggestion) {
      return parsedSuggestions.map(function (suggestion) {
        return renderSuggestion(suggestion);
      });
    }

    return parsedSuggestions;
  };

  this.setValue = function (value) {
    var isDefaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this4.props;
    var category = arguments[3];
    var cause = arguments[4];
    var hasMounted = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true; // ignore state updates when component is locked

    if (props.beforeValueChange && _this4.locked) {
      return;
    }

    _this4.locked = true;

    var performUpdate = function performUpdate() {
      if (hasMounted) {
        _this4.setState({
          currentValue: value || '',
          currentCategory: category || null,
          suggestions: []
        }, function () {
          if (isDefaultValue) {
            if (_this4.props.autosuggest) {
              _this4.setState({
                isOpen: false
              });

              _this4.updateQuery(_this4.internalComponent, value, props);
            } // in case of strict selection only SUGGESTION_SELECT should be able
            // to set the query otherwise the value should reset


            if (props.strictSelection) {
              if (cause === _causes2.default.SUGGESTION_SELECT || value === '') {
                _this4.updateQuery(props.componentId, value, props, category);
              } else {
                _this4.setValue('', true);
              }
            } else {
              _this4.updateQuery(props.componentId, value, props, category);
            }
          } else {
            // debounce for handling text while typing
            _this4.handleTextChange(value);
          }

          _this4.locked = false;
          if (props.onValueChange) props.onValueChange(value);
        });
      } else {
        _this4.updateQuery(_this4.internalComponent, value, props);

        _this4.updateQuery(props.componentId, value, props, category);

        _this4.locked = false;
        if (props.onValueChange) props.onValueChange(value);
      }
    };

    (0, _helper.checkValueChange)(props.componentId, value, props.beforeValueChange, performUpdate);
  };

  this.handleTextChange = (0, _helper.debounce)(function (value) {
    if (_this4.props.autosuggest) {
      _this4.updateQuery(_this4.internalComponent, value, _this4.props);
    } else {
      _this4.updateQuery(_this4.props.componentId, value, _this4.props);
    }
  }, this.props.debounce);

  this.updateQuery = function (componentId, value, props, category) {
    var customQuery = props.customQuery,
        filterLabel = props.filterLabel,
        showFilter = props.showFilter,
        URLParams = props.URLParams;
    var customQueryOptions = void 0;
    var defaultQueryTobeSet = CategorySearch.defaultQuery(value, props, category);
    var query = defaultQueryTobeSet;

    if (customQuery) {
      var customQueryTobeSet = customQuery(value, props, category);
      query = customQueryTobeSet.query;
      customQueryOptions = (0, _helper.getOptionsFromQuery)(customQueryTobeSet);
    } // query options should be applied to the source component,
    // not on internal component, hence using `this.props.componentId` here


    props.setQueryOptions(_this4.props.componentId, _extends({}, _this4.queryOptions, customQueryOptions));
    props.updateQuery({
      componentId: componentId,
      query: query,
      value: value,
      label: filterLabel,
      showFilter: showFilter,
      URLParams: URLParams,
      componentType: 'CATEGORYSEARCH',
      category: category
    });
  };

  this.handleFocus = function (event) {
    _this4.setState({
      isOpen: true
    });

    if (_this4.props.onFocus) {
      _this4.props.onFocus(event);
    }
  };

  this.clearValue = function () {
    _this4.setValue('', true);

    _this4.onValueSelected(null, _causes2.default.CLEAR_VALUE, null);
  };

  this.handleKeyDown = function (event, highlightedIndex) {
    // if a suggestion was selected, delegate the handling to suggestion handler
    if (event.key === 'Enter' && highlightedIndex === null) {
      _this4.setValue(event.target.value, true);

      var value = {
        term: event.target.value,
        category: null
      };

      _this4.onValueSelected(value, _causes2.default.ENTER_PRESS);
    }

    if (_this4.props.onKeyDown) {
      _this4.props.onKeyDown(event);
    }
  };

  this.onInputChange = function (e) {
    var inputValue = e.target.value;

    if (!_this4.state.isOpen) {
      _this4.setState({
        isOpen: true
      });
    }

    var _props3 = _this4.props,
        value = _props3.value,
        onChange = _props3.onChange;

    if (value === undefined) {
      _this4.setValue(inputValue);
    } else if (onChange) {
      onChange({
        term: inputValue // category: null,

      });
    } else {
      _this4.setValue(inputValue);
    }
  };

  this.onSuggestionSelected = function (suggestion) {
    var _props4 = _this4.props,
        value = _props4.value,
        onChange = _props4.onChange;
    var currentValue = {
      term: suggestion.value,
      category: suggestion.category || null
    };

    if (value === undefined) {
      _this4.setValue(currentValue.term, true, _this4.props, currentValue.category, _causes2.default.SUGGESTION_SELECT);
    } else if (onChange) {
      onChange(currentValue);
    } // onValueSelected is user interaction driven:
    // it should be triggered irrespective of controlled (or)
    // uncontrolled component behavior


    _this4.onValueSelected(currentValue, _causes2.default.SUGGESTION_SELECT, suggestion.source);
  };

  this.onValueSelected = function (selectedValue, cause, source) {
    var onValueSelected = _this4.props.onValueSelected;

    if (onValueSelected) {
      onValueSelected(selectedValue, cause, source);
    }
  };

  this.handleStateChange = function (changes) {
    var isOpen = changes.isOpen,
        type = changes.type;

    if (type === _downshift2.default.stateChangeTypes.mouseUp) {
      _this4.setState({
        isOpen: isOpen
      });
    }
  };

  this.getBackgroundColor = function (highlightedIndex, index) {
    var isDark = _this4.props.themePreset === 'dark';

    if (isDark) {
      return highlightedIndex === index ? '#555' : '#424242';
    }

    return highlightedIndex === index ? '#eee' : '#fff';
  };

  this.handleSearchIconClick = function () {
    var currentValue = _this4.state.currentValue;

    if (currentValue.trim()) {
      _this4.setValue(currentValue, true);
    }
  };

  this.renderIcon = function () {
    if (_this4.props.showIcon) {
      return _this4.props.icon || _react2.default.createElement(_SearchSvg2.default, null);
    }

    return null;
  };

  this.renderCancelIcon = function () {
    if (_this4.props.showClear) {
      return _this4.props.clearIcon || _react2.default.createElement(_CancelSvg2.default, null);
    }

    return null;
  };

  this.renderIcons = function () {
    return _react2.default.createElement('div', null, _this4.state.currentValue && _this4.props.showClear && _react2.default.createElement(_InputIcon2.default, {
      onClick: _this4.clearValue,
      iconPosition: 'right',
      clearIcon: _this4.props.iconPosition === 'right'
    }, _this4.renderCancelIcon()), _react2.default.createElement(_InputIcon2.default, {
      onClick: _this4.handleSearchIconClick,
      iconPosition: _this4.props.iconPosition
    }, _this4.renderIcon()));
  };

  this.renderNoSuggestion = function () {
    var finalSuggestionsList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var _props5 = _this4.props,
        themePreset = _props5.themePreset,
        theme = _props5.theme,
        isLoading = _props5.isLoading,
        renderNoSuggestion = _props5.renderNoSuggestion,
        innerClass = _props5.innerClass,
        renderError = _props5.renderError,
        error = _props5.error;
    var _state = _this4.state,
        isOpen = _state.isOpen,
        currentValue = _state.currentValue;

    if (renderNoSuggestion && isOpen && !finalSuggestionsList.length && !isLoading && currentValue && !(renderError && error)) {
      return _react2.default.createElement(_SuggestionWrapper2.default, {
        innerClass: innerClass,
        themePreset: themePreset,
        theme: theme,
        innerClassName: 'noSuggestion'
      }, typeof renderNoSuggestion === 'function' ? renderNoSuggestion(currentValue) : renderNoSuggestion);
    }

    return null;
  };

  this.renderLoader = function () {
    var _props6 = _this4.props,
        loader = _props6.loader,
        isLoading = _props6.isLoading,
        themePreset = _props6.themePreset,
        theme = _props6.theme,
        innerClass = _props6.innerClass;
    var currentValue = _this4.state.currentValue;

    if (isLoading && loader && currentValue) {
      return _react2.default.createElement(_SuggestionWrapper2.default, {
        innerClass: innerClass,
        innerClassName: 'loader',
        theme: theme,
        themePreset: themePreset
      }, loader);
    }

    return null;
  };

  this.renderError = function () {
    var _props7 = _this4.props,
        error = _props7.error,
        renderError = _props7.renderError,
        themePreset = _props7.themePreset,
        theme = _props7.theme,
        isLoading = _props7.isLoading,
        innerClass = _props7.innerClass;
    var currentValue = _this4.state.currentValue;

    if (error && renderError && currentValue && !isLoading) {
      return _react2.default.createElement(_SuggestionWrapper2.default, {
        innerClass: innerClass,
        innerClassName: 'error',
        theme: theme,
        themePreset: themePreset
      }, (0, _utils.isFunction)(renderError) ? renderError(error) : renderError);
    }

    return null;
  };
};

CategorySearch.propTypes = {
  addComponent: _types2.default.funcRequired,
  removeComponent: _types2.default.funcRequired,
  setQueryListener: _types2.default.funcRequired,
  setQueryOptions: _types2.default.funcRequired,
  updateQuery: _types2.default.funcRequired,
  watchComponent: _types2.default.funcRequired,
  options: _types2.default.options,
  categories: _types2.default.data,
  selectedValue: _types2.default.selectedValue,
  selectedCategory: _types2.default.selectedValue,
  suggestions: _types2.default.suggestions,
  // component props
  autoFocus: _types2.default.bool,
  autosuggest: _types2.default.bool,
  beforeValueChange: _types2.default.func,
  categoryField: _types2.default.string,
  className: _types2.default.string,
  clearIcon: _types2.default.children,
  componentId: _types2.default.stringRequired,
  customHighlight: _types2.default.func,
  customQuery: _types2.default.func,
  dataField: _types2.default.dataFieldArray,
  debounce: _types2.default.number,
  // eslint-disable-next-line
  error: _types2.default.any,
  defaultValue: _types2.default.categorySearchValue,
  value: _types2.default.categorySearchValue,
  defaultSuggestions: _types2.default.suggestions,
  downShiftProps: _types2.default.props,
  fieldWeights: _types2.default.fieldWeights,
  filterLabel: _types2.default.string,
  fuzziness: _types2.default.fuzziness,
  highlight: _types2.default.bool,
  highlightField: _types2.default.stringOrArray,
  icon: _types2.default.children,
  iconPosition: _types2.default.iconPosition,
  innerClass: _types2.default.style,
  isLoading: _types2.default.bool,
  loader: _types2.default.title,
  nestedField: _types2.default.string,
  onError: _types2.default.func,
  onBlur: _types2.default.func,
  onFocus: _types2.default.func,
  onKeyDown: _types2.default.func,
  onKeyPress: _types2.default.func,
  onKeyUp: _types2.default.func,
  onQueryChange: _types2.default.func,
  onSuggestions: _types2.default.func,
  onValueChange: _types2.default.func,
  onChange: _types2.default.func,
  onValueSelected: _types2.default.func,
  placeholder: _types2.default.string,
  queryFormat: _types2.default.queryFormatSearch,
  react: _types2.default.react,
  renderError: _types2.default.title,
  renderSuggestion: _types2.default.func,
  renderAllSuggestions: _types2.default.func,
  renderNoSuggestion: _types2.default.title,
  showClear: _types2.default.bool,
  showFilter: _types2.default.bool,
  showIcon: _types2.default.bool,
  style: _types2.default.style,
  title: _types2.default.title,
  theme: _types2.default.style,
  themePreset: _types2.default.themePreset,
  URLParams: _types2.default.bool,
  strictSelection: _types2.default.bool
};
CategorySearch.defaultProps = {
  autosuggest: true,
  className: null,
  debounce: 0,
  downShiftProps: {},
  iconPosition: 'left',
  placeholder: 'Search',
  queryFormat: 'or',
  showClear: false,
  showFilter: true,
  showIcon: true,
  style: {},
  URLParams: false,
  strictSelection: false
};

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    categories: state.aggregations[props.componentId] && state.aggregations[props.componentId][props.categoryField] && state.aggregations[props.componentId][props.categoryField].buckets || [],
    selectedValue: state.selectedValues[props.componentId] && state.selectedValues[props.componentId].value || null,
    selectedCategory: state.selectedValues[props.componentId] && state.selectedValues[props.componentId].category || null,
    suggestions: state.hits[props.componentId] && state.hits[props.componentId].hits || [],
    themePreset: state.config.themePreset,
    isLoading: state.isLoading[props.componentId],
    error: state.error[props.componentId]
  };
};

var mapDispatchtoProps = function mapDispatchtoProps(dispatch) {
  return {
    addComponent: function addComponent(component) {
      return dispatch((0, _actions.addComponent)(component));
    },
    removeComponent: function removeComponent(component) {
      return dispatch((0, _actions.removeComponent)(component));
    },
    setQueryOptions: function setQueryOptions(component, props, execute) {
      return dispatch((0, _actions.setQueryOptions)(component, props, execute));
    },
    setQueryListener: function setQueryListener(component, onQueryChange, beforeQueryChange) {
      return dispatch((0, _actions.setQueryListener)(component, onQueryChange, beforeQueryChange));
    },
    updateQuery: function updateQuery(updateQueryObject) {
      return dispatch((0, _actions.updateQuery)(updateQueryObject));
    },
    watchComponent: function watchComponent(component, react) {
      return dispatch((0, _actions.watchComponent)(component, react));
    }
  };
};

var ConnectedComponent = (0, _utils.connect)(mapStateToProps, mapDispatchtoProps)(function (props) {
  return _react2.default.createElement(CategorySearch, _extends({
    ref: props.myForwardedRef
  }, props));
}); // eslint-disable-next-line

var ForwardRefComponent = _react2.default.forwardRef(function (props, ref) {
  return _react2.default.createElement(ConnectedComponent, _extends({}, props, {
    myForwardedRef: ref
  }));
});

(0, _hoistNonReactStatics2.default)(ForwardRefComponent, CategorySearch);
ForwardRefComponent.name = 'CategorySearch';
exports.default = ForwardRefComponent;